import { Tooltip } from '@material-ui/core';
import { Warning } from 'phosphor-react';
import React from 'react';
import colors from 'Exports/colors.scss';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const ConsumerPriceModel = ({ consumerPriceModel }) => {
  const href = consumerPriceModel.priceMarginLink;
  const warningText = consumerPriceModel.warningText;

  const currentType = useSelector((state) => state.priceToggle?.currentType);

  const priceToggleType = currentType ?? 'NET';

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        itemProp="offers"
        itemScope
        itemType="http://schema.org/Offer"
        className="product__price--price product__price-margin-fallback">
        {consumerPriceModel.price}
        {href || warningText ? (
          <Tooltip title={warningText}>
            <a href={href}>
              <Warning color={colors['warning']} size={20} />
            </a>
          </Tooltip>
        ) : null}
      </div>
      {priceToggleType.toLowerCase() != 'net' && (
        <span
          className="product__price--list-price"
          style={{ display: 'block' }}
        >
          {translate(`price-toggle.${priceToggleType.toLowerCase()}`)}
        </span>
      )}
    </div>
  );
};

export default ConsumerPriceModel;
